<template lang="pug">
  v-date-picker(
     v-model="date"
    :class="classes"
    :locale="lang"
    mode="single"
    color="green"
    :attributes="attrs"
    :popover="{ placement: 'bottom', visibility: 'click' } ")
    .v-datepicker(
      slot-scope="{ inputProps, inputEvents, isDragging }"
      v-bind="inputProps"
      v-on="inputEvents")
      .v-datepicker__label {{ dateLabel }}
      .v-datepicker__icon
        i.i-util-date
</template>

<script>
import { formateDate, formateDateText } from '@/util'

export default {
  name: 'VDatepicker',

  props: {
    value: {
      type: String,
      default: () => formateDate(new Date())
    },
    positionRight: Boolean,
    positionLeft: Boolean,
  },

  data () {
    return {
      date: new Date()
    }
  },

  computed: {
    lang () {
      const language = this.$store.getters['account/lang']
      return language === 'us' ? 'en' : language
    },

    timezone () {
      return this.$store.getters['account/timezone']
    },

    todayDate () {
      const nowStr = new Date().toLocaleString('en-CA', { timeZone: this.timezone })
      return nowStr.split(' ')[0]
    },

    attrs () {
      if (!this.todayDate) return []
      return [{
        key: 'today',
        highlight: { color: 'green', fillMode: 'light' },
        dates: this.todayDate
      }]
    },

    classes () {
      return {
        'position-right': this.positionRight,
        'position-left': this.positionLeft
      }
    },

    dateLabel () {
      return formateDateText(this.date)
    }
  },

  watch: {
    value: {
      immediate: true,
      handler (newVal) {
        if (!newVal) return
        const parts = newVal.split('-')
        if (parts.length === 3) {
          const [year, month, day] = parts.map(Number)
          this.date = new Date(year, month - 1, day)
        }
      }
    },
    timezone (newTimezone) {
    },
    date (newDate) {
      this.$emit('input', formateDate(newDate))
    }
  }
}

</script>

<style lang="scss">
@import '@/sass/abstracts/_mixins.scss';
@import '@/sass/abstracts/_variables.scss';

.v-datepicker {
  height: 2.5rem;
  display: flex;
  cursor: pointer;

  &__label {
    margin-right: 1rem;
    user-select: none;
    font-size: 1.7rem;
    min-width: 14.5rem;
  }
}

.position-right {
  .vc-popover-content-wrapper {
    @include mobile {
      left: 6rem !important;
    }
  }

  .vc-popover-caret.align-center {
    @include mobile {
      left: 25% !important;
    }
  }
}

.position-left {
  .vc-popover-content-wrapper {
    @include mobile {
      left: -4rem !important;
    }
  }

  .vc-popover-caret.align-center {
    @include mobile {
      left: 90% !important;
    }
  }
}
</style>
